module.exports = __webpack_public_path__ + "static/media/icon-gear.e24da3e6.svg";